export default __webpack_public_path__ + "static/media/AutoVD1.42bb4da6.png";